// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeObject(target: any, source: any) {
  Object.keys(source).forEach(function (key) {
    if (source[key] && typeof source[key] === "object") {
      mergeObject((target[key] = target[key] || {}), source[key]);
      return;
    }
    target[key] = source[key];
  });
}

export const tryParse = (str: string) => {
  if (!str) {
    return;
  }
  try {
    return JSON.parse(str);
  } catch (error) {
    console.error(error);
  }
};

/** 服务端可能返回 content 中 text 被多包一层双引号导致 JSON 无效，如 {"text":""我要维修机器""} */
function stripSurroundingQuotes(s: string): string {
  let t = s;
  while (t.length >= 2 && t.startsWith('"') && t.endsWith('"')) {
    t = t.slice(1, -1);
  }
  return t;
}

/**
 * 解析消息 content 字符串，兼容被错误多包一层双引号的情况（如 {"text":""xxx""}）
 */
export function parseMessageContent(
  str: string,
): { text?: string; [key: string]: unknown } | undefined {
  if (!str || typeof str !== "string") return undefined;
  try {
    const parsed = JSON.parse(str);
    if (parsed && typeof parsed.text === "string") return parsed;
    return undefined;
  } catch {
    // 尝试从畸形 JSON 中提取 text（如 {"text":""我要维修机器""}）
    const doubleQuoted = str.match(/"text"\s*:\s*""(.*?)""\s*[\},]/);
    if (doubleQuoted) return { text: doubleQuoted[1] };
    const singleQuoted = str.match(/"text"\s*:\s*"(.*?)"\s*[\},]/);
    if (singleQuoted) return { text: stripSurroundingQuotes(singleQuoted[1]) };
    return undefined;
  }
}

/**
 * 从对象中移除指定的键，并返回新对象
 * @param obj 原始对象
 * @param keysToRemove 需要移除的键数组
 * @returns 移除指定键后的新对象
 */
export function removeObjectKeys<T extends object, K extends keyof T>(
  obj: T,
  keysToRemove: K[],
): Omit<T, K> {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (!keysToRemove.includes(key as K)) {
        acc[key as keyof Omit<T, K>] = value;
      }
      return acc;
    },
    {} as Omit<T, K>,
  );
}
